import React from 'react';
import { Image, Text, View } from 'react-native';
import { no_results_image, select_contacts_title } from '../../../../../utils/DictionaryManagementUtils';
import { getImageByKey } from '../../../../../utils/ImagesManagementUtils';
import FullPageSimulator from '../../FullPageSimulator';
import { textLink_7_0, textSecondary_9_3 } from '../../../AuxiliaryComponent/TextComponent/TextStyle';
import SearchContactHeadLine from '../../../../ContactList/SearchContactHeadLine';

//= ========================================================================

const NoResultsContactFP = ({
  globJSON,
  simPlatform,
  slideshowRefs,
  subCategoryId,
  headlineText = select_contacts_title,
  text,
  noResultsImage,
}) => {
  const { recipient } = globJSON.configurations.services[subCategoryId];

  const myStyles = {
    margin: {
      marginTop: 5,
    },
    noResultsContainer: {
      paddingVertical: '1%',
    },
    magnifyingLensImage: {
      width: 37,
      height: 37,
      alignSelf: 'center',
    },
  };
  const img = getImageByKey(globJSON.configurations.launch.keyboard.no_results_image, no_results_image);
  return (
    <FullPageSimulator
      globJSON={globJSON}
      simPlatform={simPlatform}
      keyboardType="lettersKeyboard"
      withExtraHeightForTitle
      headlineText={headlineText}
      withOutPadding
      slideshowRefs={slideshowRefs}
    >
      <View style={myStyles.margin}>
        <SearchContactHeadLine globJSON={globJSON} subCategoryId={subCategoryId} simPlatform={simPlatform} text={text} textBlack withCloseIcon />
      </View>
      <View style={myStyles.noResultsContainer}>
        <Text style={[textSecondary_9_3(globJSON, simPlatform), { textAlign: 'center', color: '#001a2f' }]}>{recipient.no_results}</Text>
      </View>
      {noResultsImage
        ? (
          <Image
            fadeDuration={0}
            resizeMode="contain"
            style={myStyles.magnifyingLensImage}
            source={img}
          />
        )
        : (
          <Text style={[textLink_7_0(globJSON, simPlatform), {
            paddingVertical: 1,
            alignSelf: 'center',
          }]}
          >
            {recipient.translate_to}
          </Text>
        )}
    </FullPageSimulator>

  );
};
export default NoResultsContactFP;
